import articlesActions from './articles'
import authActions from './auth'
import counterStrikeGlobalOffensiveActions from './counterStrikeGlobalOffensive'
import currentGamerActions from './currentGamer'
import currentGamerProfileActions from './currentGamerProfile'
import currentGamerPurchaseProfileActions from './currentGamerPurchaseProfile'
import dialogActions from './dialog'
import flickPowerRankingsActions from './flickPowerRankings'
import flickPowerRankingCountActions from './flickPowerRankingCount'
import followThroughPowerRankingsActions from './followThroughPowerRankings'
import followThroughPowerRankingCountActions from './followThroughPowerRankingCount'
import gameInterfaceActions from './gameInterface'
import gamerActions from './gamers'
import gameSoundActions from './gameSounds'
import mobilePowerRankingCountActions from './mobilePowerRankingCount'
import mobilePowerRankingActions from './mobilePowerRankings'
import overallStatisticsActions from './overallStatistics'
import powerRankingCountActions from './powerRankingCount'
import powerRankingActions from './powerRankings'
import purchaseActions from './purchases'
import routeParamsActions from './routeParams'
import scoreActions from './scores'
import snackbarActions from './snackbar'
import speedPowerRankingsActions from './speedPowerRankings'
import speedPowerRankingCountActions from './speedPowerRankingCount'
import supportActions from './support'
import trackingPowerRankingsActions from './trackingPowerRankings'
import trackingPowerRankingCountActions from './trackingPowerRankingCount'
import userInterfaceActions from './userInterface'

export default Object.assign(
  {},
  articlesActions,
  authActions,
  counterStrikeGlobalOffensiveActions,
  currentGamerActions,
  currentGamerProfileActions,
  currentGamerPurchaseProfileActions,
  dialogActions,
  flickPowerRankingsActions,
  flickPowerRankingCountActions,
  followThroughPowerRankingsActions,
  followThroughPowerRankingCountActions,
  gameInterfaceActions,
  gamerActions,
  gameSoundActions,
  mobilePowerRankingCountActions,
  mobilePowerRankingActions,
  overallStatisticsActions,
  powerRankingCountActions,
  powerRankingActions,
  purchaseActions,
  routeParamsActions,
  scoreActions,
  snackbarActions,
  speedPowerRankingsActions,
  speedPowerRankingCountActions,
  supportActions,
  trackingPowerRankingsActions,
  trackingPowerRankingCountActions,
  userInterfaceActions,
)



// WEBPACK FOOTER //
// ./src/app/actions/index.js